export { CustomerCrudIndex } from './crud-index';
export { CustomerIndexComponent } from './crud-index.component';
export { CustomerIndexSelectComponent } from './crud-index-select.component';
export { CustomerIndexMultiSelectComponent } from './crud-index-multiselect.component';

